module.exports = __webpack_public_path__ + "static/foto-927263d598f0237ca49004cd79e495a7.jpg";